export function createComponent(html: string, styles: string): HTMLElement {
  const host = document.createElement('div');
  const styleElement = document.createElement('style');
  const template = document.createElement('template');

  template.innerHTML = html.trim();
  const htmlElement = template.content.cloneNode(true);

  styleElement.textContent = styles;

  const shadow = host.attachShadow({ mode: 'open' });

  shadow.appendChild(styleElement);
  shadow.appendChild(htmlElement);

  return host;
}

export function siteUrl(relativeUrl: string): string {
  return `${import.meta.env.VITE_SITE_URL}${relativeUrl}`;
}
